module.exports = __webpack_public_path__ + "static/pt-serif-v12-latin-regular-f88b728c1448f05a4612c32be163c55f.woff";